// src/pages/ClientPanel/Products/filterproduct/filterstyle.ts

import styled from 'styled-components';

// --- ESTILOS DO DROPDOWN (A CAIXA INTEIRA QUE APARECE) ---
// NO ARQUIVO filterstyle.ts, MODIFIQUE APENAS ESTA PARTE:

export const FilterDropdownContainer = styled.div<{ $top: number; $left: number; $width: number }>`
  position: absolute;
  top: ${props => props.$top + 5}px; /* Adiciona 5px para dar um pequeno espaço abaixo do botão */
  left: ${props => props.$left}px;   /* Começa na mesma posição X do botão */
  
  /* Ajuste de largura: */
  width: 250px; /* Largura fixa que parece mais adequada para um dropdown de filtro */
  /* Ou, se quiser que seja a largura do botão, mas com um mínimo: */
  /* width: max(180px, ${props => props.$width}px); */ /* Mínimo de 180px ou a largura do botão */
  
  background-color: white;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.15);
  padding: 20px;
  z-index: 1000;
  display: flex;
  flex-direction: column;
  gap: 15px;
`;

// MANTENHA O RESTANTE DO filterstyle.ts SEM MUDANÇAS (DropdownCloseButton, FilterSelect, ApplyFilterButton)
// --- ESTILO PARA O BOTÃO DE FECHAR DO DROPDOWN (opcional) ---
export const DropdownCloseButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  padding: 5px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute; /* Posiciona no canto superior direito do dropdown */
  top: 10px;
  right: 10px;
  img {
    width: 14px;
    height: 14px;
    opacity: 0.6;
    transition: opacity 0.2s ease;
  }
  &:hover img {
    opacity: 1;
  }
`;

// --- ESTILOS DOS ELEMENTOS INTERNOS DO FILTRO (O SELECT E O BOTÃO DE APLICAR) ---

// Estilo para o seletor de filtro (o <select> )
export const FilterSelect = styled.select`
  width: 100%;
  padding: 12px 20px;
  margin-bottom: 20px;
  border: 1px solid #e0e0e0;
  border-radius: 25px;
  background-color: #f0f0f0;
  font-size: 16px;
  appearance: none; /* Remove a seta padrão do navegador */
  -webkit-appearance: none; /* Para navegadores WebKit (Chrome, Safari) */
  -moz-appearance: none; /* Para navegadores Mozilla (Firefox) */
  /* Imagem de fundo para simular uma seta personalizada */
  background-image: url('data:image/svg+xml;charset=US-ASCII,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%22292.4%22%20height%3D%22292.4%22%3E%3Cpath%20fill%3D%22%23000000%22%20d%3D%22M287%2C197.3L159.2%2C69.5c-3.1-3.1-8.2-3.1-11.3%2C0L13.1%2C197.3c-3.1%2C3.1-3.1%2C8.2%2C0%2C11.3l11.3%2C11.3c3.1%2C3.1%2C8.2%2C3.1%2C11.3%2C0l110-110c3.1-3.1%2C8.2-3.1%2C11.3%2C0l110%2C110c3.1%2C3.1%2C8.2%2C3.1%2C11.3%2C0l11.3-11.3C290.1%2C205.5%2C290.1%2C200.4%2C287%2C197.3z%22%2F%3E%3C%2Fsvg%3E');
  background-repeat: no-repeat;
  background-position: right 15px center; /* Posição da seta */
  background-size: 12px; /* Tamanho da seta */
  cursor: pointer;
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.1);
`;

// Estilo para o botão "Aplicar filtro"
export const ApplyFilterButton = styled.button`
  background-color: #009DFF;
  color: white;
  border: none;
  border-radius: 25px;
  padding: 15px 25px;
  font-size: 18px;
  cursor: pointer;
  width: 100%;
  margin-top: 10px;
  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);
  transition: background-color 0.3s ease, box-shadow 0.3s ease;

  &:hover {
    background-color: #009DFF;
  }
`;